import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import useLocationsHook from "../../hooks/locationHook";
import { t } from "i18next";
import { formatCurrencyWithSymbol } from "../../utils/formatCurrencyWithSymbol";
const PriceLabel = (props) => {
    const [showMenu, setShowMenu] = useState(false);
    const [screeWidth, setScreenWidth] = useState(window.innerWidth);
    const [selectedCurrency, setSelectedCurrency] = useState("");
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const countries = useLocationsHook();
    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    //events
    const handleButtonClick = (event) => {
        //do a click to the element with id localization_header
        const localizationHeader = document.getElementById("localization_header");
        localizationHeader === null || localizationHeader === void 0 ? void 0 : localizationHeader.click();
        //change the position of an element with id currency_container so it appears on the right side of the element with class car_reservation
        const carReservation = document.querySelector(".transaction");
        const currencyContainer = document.getElementById("currency_container");
        if (carReservation && currencyContainer) {
            const rect = carReservation.getBoundingClientRect();
            // add to the left the witdh of carReservation
            if (window.innerWidth > 768) {
                currencyContainer.style.left = rect.left + rect.width + 10 + "px";
                currencyContainer.style.right = "auto";
                currencyContainer.style.position = "fixed";
            }
        }
    };
    useEffect(() => {
        //if an element of class currency__close is clicked remove the syles of the element with id currency_container using an event listener
        const close = document.querySelector(".currency__close");
        const currencyContainer = document.getElementById("currency_container");
        currencyContainer === null || currencyContainer === void 0 ? void 0 : currencyContainer.removeAttribute("style");
        close === null || close === void 0 ? void 0 : close.addEventListener("click", () => {
            currencyContainer === null || currencyContainer === void 0 ? void 0 : currencyContainer.removeAttribute("style");
        });
    }, []);
    const handleSelectLocation = () => {
        const form = document.getElementById("HeaderCountryForm");
        if (form) {
            const country_code = document.getElementById("country_code");
            country_code.value = selectedCurrency;
            form.submit();
        }
        setShowMenu(false);
    };
    useEffect(() => {
        if (selectedCurrency !== undefined && selectedCurrency !== "") {
            handleSelectLocation();
        }
    }, [selectedCurrency]);
    return (_jsx("div", { className: `price-label ${props.size === "big" ? "big" : ""}`, children: _jsx("div", { className: "price-label__inner", onClick: handleButtonClick, id: "finalpricelabel", children: _jsx("span", { className: "price-label__price", children: formatCurrencyWithSymbol(t(props.currency + "_f"), props.price) }) }) }));
};
export default PriceLabel;
